import React, {
  useCallback,
  useEffect,
  useState,
  useRef,
  useMemo,
} from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Select from "react-select";
import "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import fileDownload from "js-file-download";
import {
  agGridOptionsSingle,
  agGridTheme,
  HOST_URL,
  MandatoryExplanation,
  MandatoryFieldIndicator,
  submittalFileTypes,
} from "../../helpers/constants/Constants";
import {
  addTaskSubmittal,
  deleteSubmittal,
  getAllSubmittals,
} from "../../helpers/axios/projectsAxios";
import {
  ALL_PROJECT_SUBMITTALS,
  updateGlobalState,
} from "../../helpers/reducers/GlobalReducer";

const Submittals = () => {
  const {
    userDetails,
    allProjectSubmittals,
    selectedProject,
    allProjectUsers,
  } = useSelector((state) => state.globalReducer);
  const [submitting, setSubmitting] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState();
  const [deleting, setDeleting] = useState(false);
  const [submittalData, setSubmittalData] = useState();
  const [submittalModal, setSubmittalModal] = useState(false);
  const [confirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [gridPageSizeMode, setGridPageSizeMode] = useState("auto");

  const dispatch = useDispatch();

  useEffect(() => {
    if (allProjectSubmittals) {
      setRowData(allProjectSubmittals);
    }
  }, [allProjectSubmittals]);

  const onClosesubmittalModal = () => {
    setSubmittalModal(false);
    setSubmittalData();
  };

  const submittalInfoChangeHandler = (e, type) => {
    const tempComment = {
      id: 1,
      user: userDetails.email,
      date: new Date().toISOString(),
    };
    if (e.target) {
      if (type === "comment") {
        setSubmittalData({
          ...submittalData,
          [type]: { ...tempComment, comment: e.target.value },
        });
      } else {
        setSubmittalData({
          ...submittalData,
          [type]: e.target.value,
        });
      }
    } else {
      setSubmittalData({
        ...submittalData,
        [type]: e.value,
      });
    }
  };

  // const submittalFileTypes = [
  //   { name: "Revit", code: ".rvt" },
  //   { name: "Navisworks (D)", code: ".nwd" },
  //   { name: "IFC", code: ".ifc" },
  //   { name: "STP", code: ".stp" },
  //   { name: "Navisworks (C)", code: ".nwc" },
  //   { name: "DWFX", code: ".dwfx" },
  //   { name: "AutoCAD / Civil 3D", code: ".dwg" },
  //   { name: "Navisworks (F)", code: ".nwf" },
  //   { name: "Bentley Microstation", code: ".dgn" },
  //   { name: "Microsoft Word", code: ".doc" },
  //   { name: "Microsoft Excel", code: ".xlsx" },
  // ];

  const createSubmittal = async () => {
    setSubmitting(true);
    const selectedModel = gridApi.getSelectedRows()[0];
    const tempSubmittalData = {
      ...submittalData,
      selectedModel: selectedModel.projectAssetTask,
    };
    const addSubmittalMessage = await addTaskSubmittal(tempSubmittalData);
    window.alert(addSubmittalMessage.message);
    await fetchAllSubmittals(selectedProject[0].id);
    onClosesubmittalModal();
    setSubmitting(false);
  };

  const fitGridColumns = useCallback(
    (apiInput) => {
      const api = apiInput || gridApi;
      if (!api) return;

      api.sizeColumnsToFit();
    },
    [gridApi],
  );

  const applyGridPageSizeMode = useCallback(
    (apiInput) => {
      const api = apiInput || gridApi;
      if (!api) return;

      const allRowCount = Math.max(rowData?.length || 0, 1);

      if (gridPageSizeMode === "all") {
        api.setGridOption("paginationAutoPageSize", false);
        api.setGridOption("paginationPageSize", allRowCount);
      } else if (gridPageSizeMode === "auto") {
        api.setGridOption("paginationAutoPageSize", true);
      } else {
        const pageSize = Number(gridPageSizeMode) || 25;
        api.setGridOption("paginationAutoPageSize", false);
        api.setGridOption("paginationPageSize", pageSize);
      }

      api.paginationGoToFirstPage();
    },
    [gridApi, gridPageSizeMode, rowData],
  );

  useEffect(() => {
    applyGridPageSizeMode();
    fitGridColumns();
  }, [applyGridPageSizeMode, fitGridColumns]);

  const gridReady = (params) => {
    setGridApi(params.api);
    requestAnimationFrame(() => {
      fitGridColumns(params.api);
      applyGridPageSizeMode(params.api);
    });
  };

  const [colDefs] = useState([
    { field: "id", hide: true },
    {
      colId: "Document Number",
      valueGetter: (p) => p.data?.projectAssetTask?.docNumber,
      rowGroup: true,
      hide: true,
      sort: "asc",
    },

    {
      headerName: "Regional Designation",
      valueGetter: (p) => p.data?.projectAssetTask?.projectAsset.asset.name,
      // checkboxSelection: true,
    },
    {
      headerName: "MWH Asset",
      valueGetter: (p) => p.data?.projectAssetTask?.mwhAssetName,
    },
    {
      headerName: "Title",
      valueGetter: (p) => p.data?.projectAssetTask?.task,
    },
    {
      headerName: "Discipline",
      valueGetter: (p) => p.data?.projectAssetTask?.discipline,
    },
    {
      headerName: "Supplier Representative",
      valueGetter: (p) => p.data?.supplierRep,
    },
    {
      headerName: "Reviewer",
      valueGetter: (p) => p.data?.responsiblePerson,
    },
    {
      headerName: "Format",
      valueGetter: (p) => p.data?.fileType,
      width: 120,
    },
    {
      headerName: "Status",
      valueGetter: (p) => p.data?.status,
      width: 120,
    },
    {
      headerName: "ACC Version",
      valueGetter: (p) => p.data?.accVersion,
      width: 120,
    },
  ]);

  const defaultColDef = useMemo(
    () => ({
      resizable: true,
    }),
    [],
  );

  const gridRef = useRef();

  const selectionChanged = () => {
    setSelectedFiles(gridApi.getSelectedRows());
  };

  const autoGroupColumnDef = useMemo(() => {
    return {
      headerName: "docName",
      valueGetter: (p) => p.data?.projectAssetTask.projectAsset.asset.name,
      minWidth: 250,
      cellRenderer: "agGroupCellRenderer",
    };
  }, []);

  // const rowSelection = useMemo(() => {
  //   return {
  //     mode: "singleRow",
  //     groupSelects: "self",
  //     checkboxLocation: "autoGroupColumn",
  //   };
  // }, []);

  // const downloadRights = ["Admin", "Design Manager"]; //add roles here you want to be able to download files

  const downloadFile = async () => {
    axios
      .get(HOST_URL + "/projects/getSubmittalFile", {
        responseType: "blob",
        withCredentials: true,
        params: {
          projectId: selectedFiles[0].projectAssetTask.projectAsset.projectId,
          docNumber: selectedFiles[0].projectAssetTask.docNumber,
          version: selectedFiles[0].accVersion,
        },
      })
      .then((res) => {
        fileDownload(
          res.data,
          selectedFiles[0].projectAssetTask.docNumber +
            selectedFiles[0].fileType,
        );
      });
  };

  const fetchAllSubmittals = async (projectId) => {
    const data = await getAllSubmittals(projectId);
    dispatch(
      updateGlobalState({
        value: data,
        stateName: ALL_PROJECT_SUBMITTALS,
      }),
    );
  };

  const selectedDeleteHandler = () => {
    setConfirmDeleteModalOpen(true);
  };

  const confirmDeleteSubmittal = async () => {
    setDeleting(true);
    try {
      const submittalId = gridApi.getSelectedRows()[0].id;
      const deleteSubmittalMessage = await deleteSubmittal(
        submittalId,
        selectedProject[0].id,
      );
      await fetchAllSubmittals(selectedProject[0].id);
      window.alert(deleteSubmittalMessage.message);
      setSelectedFiles([]);
      setConfirmDeleteModalOpen(false);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className="project-config-page">
      <Container className="project-config-shell">
        <h1 className="project-config-title">Submittals</h1>
        {userDetails?.projectAdmin && (
          <>
            <Row>
              <Col
                className="project-config-actions"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  paddingTop: "8px",
                  flexWrap: "wrap",
                  gap: "0.5rem",
                }}
              >
                <Button
                  className="project-config-action-btn mwh-btn-primary"
                  variant="outline-info"
                  size="sm"
                  style={{ width: "150px" }}
                  onClick={() => {
                    downloadFile();
                  }}
                  disabled={
                    selectedFiles?.length === 0 ||
                    selectedFiles[0]?.status === "Requested"
                  }
                >
                  {submitting ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <span>Download File</span>
                  )}
                </Button>
                <Button
                  className="project-config-action-btn mwh-btn-warning"
                  variant="outline-warning"
                  size="sm"
                  style={{ width: "170px" }}
                  onClick={() => {
                    const currentUser = allProjectUsers.find(
                      (user) => user.email === selectedFiles[0]?.supplierRep,
                    );
                    const currentFileType = submittalFileTypes.find(
                      (type) => type.code === selectedFiles[0]?.fileType,
                    );
                    const currentResponsiblePerson = allProjectUsers.find(
                      (user) =>
                        user.email === selectedFiles[0]?.responsiblePerson,
                    );
                    setSubmittalData({
                      supplierRep: currentUser,
                      fileType: currentFileType,
                      responsiblePerson: currentResponsiblePerson,
                    });
                    setSubmittalModal(true);
                  }}
                  disabled={
                    selectedFiles?.length === 0 ||
                    selectedFiles[0]?.status !== "Approved"
                  }
                >
                  {submitting ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <span>Request Updated Model</span>
                  )}
                </Button>
                <Button
                  className="project-config-action-btn mwh-btn-danger"
                  variant="outline-danger"
                  size="sm"
                  style={{ width: "150px" }}
                  onClick={selectedDeleteHandler}
                  disabled={
                    selectedFiles?.length === 0 ||
                    selectedFiles[0]?.status !== "Requested"
                  }
                >
                  {deleting ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <span>Delete Request</span>
                  )}
                </Button>
              </Col>
            </Row>
          </>
        )}
        <Row className="project-config-grid-row">
          <div className="project-config-grid-wrap">
            <div className="project-config-grid-table">
              <AgGridReact
                theme={agGridTheme}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                ref={gridRef}
                onSelectionChanged={selectionChanged}
                groupDisplayType={"groupRows"}
                autoGroupColumnDef={autoGroupColumnDef}
                onGridReady={gridReady}
                onGridSizeChanged={(params) => {
                  fitGridColumns(params.api);
                  if (gridPageSizeMode === "auto") {
                    applyGridPageSizeMode(params.api);
                  }
                }}
                onFirstDataRendered={(params) => {
                  fitGridColumns(params.api);
                  applyGridPageSizeMode(params.api);
                }}
                paginationAutoPageSize={gridPageSizeMode === "auto"}
                paginationPageSizeSelector={false}
                gridOptions={agGridOptionsSingle}
              />
              <div className="project-config-grid-rows-view">
                <Form.Label className="mb-0 me-2">Page size</Form.Label>
                <Form.Select
                  size="sm"
                  value={gridPageSizeMode}
                  onChange={(e) => {
                    setGridPageSizeMode(e.target.value);
                  }}
                  style={{ maxWidth: "180px" }}
                >
                  <option value="auto">Auto</option>
                  <option value="25">25 per page</option>
                  <option value="50">50 per page</option>
                  <option value="100">100 per page</option>
                  <option value="all">All (scroll)</option>
                </Form.Select>
              </div>
            </div>
          </div>
        </Row>
      </Container>
      {/* MODALS */}
      <Modal
        show={submittalModal}
        onHide={onClosesubmittalModal}
        dialogClassName="model-submittal-modal project-config-modal"
        centered
      >
        <Modal.Header className="project-config-modal__header">
          <Modal.Title>Model Submittal Creation Form</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={onClosesubmittalModal}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body className="project-config-modal__body">
          <div className="row">
            <div className="col ">
              <Form.Label className="mt-1">
                Who is the supplier representative?
                <MandatoryFieldIndicator />
              </Form.Label>
              <Select
                className="mb-2"
                menuPortalTarget={document.body}
                classNamePrefix="project-config-select"
                onChange={(e) => {
                  submittalInfoChangeHandler(e, "supplierRep");
                }}
                options={allProjectUsers?.map((user) => {
                  return { label: user.email, value: user };
                })}
                value={{
                  value: submittalData?.supplierRep,
                  label: submittalData?.supplierRep?.email,
                }}
              />
              <Form.Label className="mt-1">
                What file type?
                <MandatoryFieldIndicator />
              </Form.Label>
              <Select
                className="mb-2"
                menuPortalTarget={document.body}
                classNamePrefix="project-config-select"
                onChange={(e) => {
                  submittalInfoChangeHandler(e, "fileType");
                }}
                options={submittalFileTypes?.map((type) => {
                  return { label: type.name, value: type };
                })}
                value={{
                  value: submittalData?.fileType,
                  label: submittalData?.fileType?.name,
                }}
              />

              <Form.Label className="mt-1">
                Who is resposible for reviewing the model?
                <MandatoryFieldIndicator />
              </Form.Label>
              <Select
                className="mb-2"
                menuPortalTarget={document.body}
                classNamePrefix="project-config-select"
                onChange={(e) => {
                  submittalInfoChangeHandler(e, "responsiblePerson");
                }}
                options={allProjectUsers?.map((user) => {
                  return { label: user.email, value: user };
                })}
                value={{
                  value: submittalData?.responsiblePerson,
                  label: submittalData?.responsiblePerson?.email,
                }}
              />
              <Form.Label className="mt-1">Comments</Form.Label>
              <div>
                {/* insert comments component here */}
                {/* insert text area for comments here */}
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={submittalData?.comments}
                  onChange={(e) => {
                    submittalInfoChangeHandler(e, "comment");
                  }}
                />
                {/* <Comments
                  currentUser={userDetails.email}
                  comments={submittalData?.comments}
                  submittalId={submittalData?.id}
                /> */}
              </div>
              <ButtonGroup className=" ms-4 me-4 mt-1">
                <Button
                  id="submit"
                  // type="checkbox"
                  variant="outline-success"
                  onClick={createSubmittal}
                  disabled={
                    !submittalData?.supplierRep ||
                    !submittalData?.fileType ||
                    !submittalData?.responsiblePerson
                  }
                >
                  {submitting ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <span>Request submittal</span>
                  )}
                </Button>
                {/* </ButtonGroup>
              <ButtonGroup className=" ms-4 me-4"> */}
                <Button
                  id="closeModal"
                  variant="outline-danger"
                  onClick={onClosesubmittalModal}
                >
                  Cancel
                </Button>
              </ButtonGroup>
              <MandatoryExplanation />
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={confirmDeleteModalOpen}
        onHide={() => !deleting && setConfirmDeleteModalOpen(false)}
        dialogClassName="project-info-modal app-confirm-modal"
        centered
      >
        <Modal.Header className="project-info-modal__header app-confirm-modal__header">
          <Modal.Title>Delete Submittal Request?</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close project-info-modal__close"
              onClick={() => setConfirmDeleteModalOpen(false)}
              aria-label="Close"
              disabled={deleting}
            />
          </div>
        </Modal.Header>
        <Modal.Body className="project-info-modal__body app-confirm-modal__body">
          <p className="app-confirm-modal__copy">
            Are you sure you want to delete your selected submittal request?
          </p>
          <div className="app-confirm-modal__actions">
            <button
              type="button"
              className="btn btn-outline-danger project-status-modal__action-btn"
              onClick={() => setConfirmDeleteModalOpen(false)}
              disabled={deleting}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-outline-success project-status-modal__action-btn"
              onClick={confirmDeleteSubmittal}
              disabled={deleting}
            >
              {deleting ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "Delete Request"
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Submittals;
